module.exports = __webpack_public_path__ + "static/media/(DH)_MG_6129_-_Joias_Contenporaneas.ede7a08f.jpg";